import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase';
import { MockTestCard } from './MockTestCard';
import { ArrowLeftIcon } from './icons/InterfaceIcons';

export const NEETMockTestView = ({ exam, onBack, onStartTest }) => {

    return (
        <div>Feature Coming Soon !!</div>
    );
};